<template>
  <div>
    <div class="boxgroup">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    checkList: String,
    solo: Boolean,
  },
  model: {
    prop: "checkList",
    event: "change",
  },

  provide() {
    return {
      getCheckList: () => this.checkList,
      clickBox: this.clickBox,
    };
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    isntSolo(e) {
      if (Array.isArray(e)) {
        const flag = e.some((_) => this.checkList.includes(_));
        if (flag) {
          this.checkList = this.checkList.filter((item) => !e.includes(item));
        } else {
          this.checkList = [...this.checkList, ...e];
        }
      } else {
        const flag = this.checkList.includes(e);
        if (flag) {
          this.checkList = this.checkList.filter((item) => item !== e);
        } else {
          this.checkList.push(e);
        }
      }
    },
    isSolo(e) {
      if (this.checkList === e) {
        this.$emit("change", "");
      } else {
        this.$emit("change", e);
      }
    },
    clickBox(e) {
      if (!this.$props.solo) {
        this.isntSolo(e);
      } else {
        console.log("isSolo");

        this.isSolo(e);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.boxgroup {
  min-height: 50px;
  overflow-y: auto;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-row-gap: 12px;
  grid-column-gap: 12px;
}
</style>
